import React, { useState, useContext } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from "axios"

import { State } from "layouts"
import { Input, Label } from "ui"
import S from "./Form.styled"

const initialValues = {
  email: "",
  message: "",
}

const Form = ({ details }) => {
  const { state } = useContext(State)
  const [messageSentStatus, setMessageSentStatus] = useState("")

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email(details?.invalidEmail)
        .required(details?.fieldRequired),
      message: Yup.string()
        .min(3, details?.messageMinCharacters)
        .required(details?.fieldRequired),
    }),
    onSubmit: (values, actions) => {
      setMessageSentStatus("")
      const bodyFormData = new FormData()
      bodyFormData.set("email", values.email)
      bodyFormData.set("message", values.message)

      axios({
        method: "post",
        url: `https://headless.monegroswindfarms.com/wp-json/contact-form-7/v1/contact-forms/1452/feedback`,
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${state.token}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then(response => {
          if (response.data.status === "validation_failed") {
            setMessageSentStatus(details?.messageSentFailed)
          }

          if (response.data.status === "mail_sent") {
            setMessageSentStatus(details?.sentMessage)
          }
        })
        .catch(() => {
          setMessageSentStatus(details?.messageSentFailed)
        })
        .finally(() => {
          actions.resetForm()
          actions.setSubmitting(false)
        })
    },
  })

  return (
    <S.Form onSubmit={formik.handleSubmit} id="contactForm">
      <S.Field>
        <Label id="test">{details?.emailLabel}</Label>
        <Input
          id="email"
          name="email"
          value={formik.values.email}
          type="text"
          placeholder={details?.placeholderEmail}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.errors.email && formik.touched.email && formik.errors.email}
      </S.Field>
      <S.Field>
        <Label id="test">{details?.messageLabel}</Label>
        <Input
          id="message"
          name="message"
          value={formik.values.message}
          type="textarea"
          placeholder={details?.placeholderMessage}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.errors.message &&
          formik.touched.message &&
          formik.errors.message}
      </S.Field>
      {messageSentStatus}
      <S.StyledButton type="submit" disabled={formik.isSubmitting}>
        {details?.buttonName}
      </S.StyledButton>
    </S.Form>
  )
}

export default Form
